module.exports = __webpack_public_path__ + "static/media/Fourth-FlagSmall.e8cbb01f.png";